export default "__VITE_PUBLIC_ASSET__43ed62c9__"